import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";

const CustomizationTab = ({
  data,
  getCustomizations,
  addCustomization,
  deleteCustomization,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [form, setForm] = useState({
    name: "",
    type: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAdd = async () => {
    if (!form.name || !form.type) {
      toast.error("Please fill all fields");
      return;
    }

    const res = await addCustomization({
      customization: form.name.trim(),
      customizationType: form.type,
    });

    if (res?.responseCode === "00") {
      await getCustomizations();
      setForm({ name: "", type: "" });
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedItem) return;

    const res = await deleteCustomization(selectedItem.id);

    if (res) {
      setShowModal(false);
      setSelectedItem(null);
    }
  };

  return (
    <>
   <ToastContainer/>
    <div className="space-y-6 montserrat-font-1">
   
      <div className="bg-white border rounded-xl p-6 shadow-sm montserrat-font-1">
        <h2 className="text-green-600 font-semibold mb-4">Add Customization</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="text-sm text-gray-600 mb-1 block">
              Customization
            </label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="e.g., Extra Spicy, No Garlic"
              className="w-full border rounded-md px-3 py-2 text-sm"
            />
          </div>

          <div>
            <label className="text-sm text-gray-600 mb-1 block">
              Customization Type
            </label>
            <select
              name="type"
              value={form.type}
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2 text-sm"
            >
              <option value="">Select Type</option>
              <option value="customize">Customize</option>
              <option value="add-ons">Add-ons</option>
            </select>
          </div>
        </div>

        <div className="mt-4">
          <button
            onClick={handleAdd}
            className="bg-green-600 hover:bg-green-700 text-white text-sm px-4 py-2 rounded-md"
          >
            Add
          </button>
        </div>
      </div>

      <div className="space-y-4 montserrat-font-1">
        {data?.length > 0 ? (
          data.map((item, index) => (
            <div
              key={index}
              className="bg-white border rounded-xl p-5 shadow-sm"
            >
              <div className="flex justify-between items-center mb-3">
                <h2 className="text-green-600 font-semibold text-md">
                  {item.customization} ({item.customization_type})
                </h2>

                <button
                  onClick={() => {
                    setSelectedItem(item);
                    setShowModal(true);
                  }}
                  className="bg-red-500 hover:bg-red-600 text-white text-xs px-3 py-1 rounded-md"
                >
                  Remove
                </button>
              </div>

              <div className="border-t pt-3 text-sm space-y-2 montserrat-font-1">
                <div className="flex justify-between">
                  <span className="text-gray-500">Customization:</span>
                  <span className="font-medium">{item.customization}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-500">Type:</span>
                  <span className="font-medium">{item.customization_type}</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center text-gray-500">
            No customization found
          </div>
        )}
      </div>

      {/* delete model  */}

      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center montserrat-font-1 bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-xl p-6 w-[350px] shadow-lg montserrat-font-1">
            <h2 className="text-lg font-semibold mb-3 text-red-600">
              Confirm Delete
            </h2>

            <p className="text-sm text-gray-600 mb-4">
              Are you sure you want to delete this customization?
            </p>

            {/*  Data preview */}
            <div className="bg-gray-50 p-3 rounded mb-4 text-sm">
              <div className="flex justify-between">
                <span>Name:</span>
                <span className="font-medium">
                  {selectedItem?.customization}
                </span>
              </div>

              <div className="flex justify-between mt-1">
                <span>Type:</span>
                <span className="font-medium">
                  {selectedItem?.customization_type}
                </span>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowModal(false)}
                className="px-3 py-1 text-sm border rounded-md"
              >
                Cancel
              </button>

              <button
                onClick={handleConfirmDelete}
                className="px-3 py-1 text-sm bg-red-500 text-white rounded-md"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default CustomizationTab;
